/**
 * TEXT WITH ITS RECEIPTS CLICKABLE. A seat writes "(#42533)" after a claim to
 * say which page or search it came from; printed as plain text, the number was
 * a dead end. Every "#" followed by three or more digits opens that item.
 * Shorter ones are left alone: "ranked #1" is a position, not item 1.
 */
export default function ItemRefText({ text, onOpen }: { text: string; onOpen: (id: number) => void }) {
  const parts = text.split(/(#\d{3,}\b)/);
  return (
    <>
      {parts.map((part, i) => {
        const m = /^#(\d{3,})$/.exec(part);
        return m ? (
          <button
            key={i}
            type="button"
            onClick={() => onOpen(Number(m[1]))}
            className="text-indigo-600 hover:underline dark:text-indigo-400"
            title={`Open item ${part}`}
          >
            {part}
          </button>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </>
  );
}
